import React, { useEffect, useMemo, useRef, useState } from "react";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { isEmpty, startCase } from "lodash";
import jwt_decode from "jwt-decode";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { Link, useNavigate } from "react-router-dom";
import SkyLayout from "./SkyLayout";
const SportsNew = () => {
  const [activeTab, setActiveTab] = useState("");
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const naviagte = useNavigate();
  const setSearch = useContextSelector(AuthContext, (ctx) => {
    return ctx.setSearch;
  });
  const isSportTab = useMemo(() => activeTab, [activeTab]);
  const tabs = [
    { key: "in_play", label: "In-Play" },
    { key: "today", label: "Today" },
    { key: "tomorrow", label: "Tomorrow" },
    // { key: "result", label: "Result" },
  ];
  const isFirstRun = useRef(true);
  const getData = async () => {
    setLoader(true);
    let { status, data } = await apiGet(apiPath.seriesList, {
      gameType: isSportTab,
      userId: !isEmpty(localStorage.getItem("token"))
        ? jwt_decode(localStorage.getItem("token"))?.user?._id
        : "",
    });

    if (data?.success) {
      let updated = data?.data.sort(
        (a, b) => new Date(a.eventDateTime) - new Date(b.eventDateTime)
      );
      setData(updated);
    }
    setLoader(false);
  };
  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return; // skip initial run if needed
    }

    getData();
  }, [isSportTab]);
  let ImageURL = require("../../assets/images/transparent.gif");
  return (
    <SkyLayout>
      <div className="mian-wrap">
        <h3 id="quickHeader">Quick Links</h3>
        {isEmpty(activeTab) && (
          <ul className="quick_link" id="quickBoard">
            <li>
              <Link to="/inplay-sky">
                <img className="icon-inplay" src={ImageURL} />
                In-Play
              </Link>
            </li>
            <li>
              <Link to={"/favourite-sky"}>
                <img className="icon-pin" src={ImageURL} />
                Multi Markets
              </Link>
            </li>
            <li>
              <Link
                onClick={() => setActiveTab("cricket")}
                to="#"
                id="quickLink_4"
              >
                <img className="icon-cricket" src={ImageURL} />
                Cricket
              </Link>
            </li>
            <li>
              <Link
                onClick={() => setActiveTab("soccer")}
                to="#"
                id="quickLink_1"
              >
                <img className="icon-soccer" src={ImageURL} />
                Soccer
              </Link>
            </li>
            <li>
              <Link
                to="#"
                id="quickLink_2"
                onClick={() => setActiveTab("tennis")}
              >
                <img className="icon-tennis" src={ImageURL} />
                Tennis
              </Link>
            </li>
          </ul>
        )}
        {!isEmpty(activeTab) && (
          <>
            <div className="path-wrap" id="naviMenuBar">
              <Link
                to={"#"}
                onClick={() => setActiveTab("")}
                className="go_back"
              >
                Back
              </Link>
              <ul id="barList">
                <li id="allSports">All Sports</li>
                <li id="barTemplate">{startCase(activeTab)}</li>
              </ul>
            </div>
            <div className="sportlist-wrap">
              <ul
                className="menu-list"
                id="naviMenuGroup"
                style={{
                  display: "block",
                }}
              >
                {data?.length > 0 &&
                  data?.map((res) => {
                    return (
                      <div
                        id="naviMenuGroupTopCompetition"
                        style={{
                          display: "block",
                        }}
                      >
                        <h4> {res?.seriesName}</h4>
                        {res?.matchList?.map((item) => {
                          return (
                            <li
                              competitionname="CSA Provincial T20 Cup"
                              style={{
                                display: "list-item",
                              }}
                            >
                              <Link
                                to={`/match-detail-sky/${item?.eventId}/${item?.marketId}`}
                              >
                                {item?.eventName}
                              </Link>
                            </li>
                          );
                        })}
                      </div>
                    );
                  })}
              </ul>
            </div>
          </>
        )}

        {isEmpty(activeTab) && (
          <>
            <h3 className="search-bar" id="naviMenuHeader">
              All Sports
              <a
                onClick={(e) => {
                  e.preventDefault();
                  setSearch(true);
                }}
                className="a-search"
                href="#"
                onclick="javascript:MobileSearchEventHandler.openSearchWrap();"
              >
                Search
              </a>
            </h3>
            <ul
              className="menu-list"
              id="naviMenuList"
              style={{
                display: "block",
              }}
            >
              <li
                onClick={() => setActiveTab("cricket")}
                className=""
                eventname="CRICKET"
                eventtype="4"
                id="naviMenu_4"
                style={{
                  display: "list-item",
                }}
                title="CRICKET"
              >
                <a onClick={(e) => e.preventDefault()} href="#">
                  Cricket
                </a>
              </li>
              <li
                onClick={() => setActiveTab("soccer")}
                className=""
                eventname="SOCCER"
                eventtype="1"
                id="naviMenu_1"
                style={{
                  display: "list-item",
                }}
                title="SOCCER"
              >
                <a onClick={(e) => e.preventDefault()} href="#">
                  Soccer
                </a>
              </li>
              <li
                onClick={() => setActiveTab("tennis")}
                className=""
                eventname="TENNIS"
                eventtype="2"
                id="naviMenu_2"
                style={{
                  display: "list-item",
                }}
                title="TENNIS"
              >
                <a onClick={(e) => e.preventDefault()} href="#">
                  Tennis
                </a>
              </li>
            </ul>{" "}
          </>
        )}
      </div>
    </SkyLayout>
  );
};

export default SportsNew;
